<template>
  <div class="main-body">
    <div class="title-bar">
      <h1>Administration</h1>
      <div class="actions">
        <button v-if="$route.name == 'admin-assign-salesperson'" :disabled="!isDirty || isSaving" :class="{ 'square-btn': true, saving: isSaving }" @click="save()">Save<img src="../assets/spinner.svg" /></button>
        <button v-if="$route.name == 'admin-users'" class="add-square-btn" @click="add()"><img src="../assets/plus-symbol.svg" />Add</button>

        <Dropdown v-if="$route.name == 'admin-logs'" label="Since" :options="['Last Week', 'Last Month', 'Last 3 Months', 'Last Year', 'All Time']" class="primary-input" style="min-width: 10rem" v-model="since" />

        <Dropdown
          v-if="$route.name == 'admin-logs'"
          label="Type"
          :options="[{ text: 'All', value: 'all' }, ...logActions.map((action) => ({ text: action.ACTION, value: action.ACTION }))]"
          class="primary-input"
          style="min-width: 13rem"
          v-model="type" />

        <Dropdown
          v-if="$route.name == 'admin-logs'"
          label="User"
          :options="[{ value: 'all', text: 'All' }, ...allUsers.map((user) => ({ value: user.USERID, text: user.DISPLAYNAME }))]"
          class="primary-input"
          style="min-width: 15rem"
          v-model="user" />
      </div>
    </div>
    <nav class="tabs">
      <router-link :class="{ active: $route.name == 'admin-options' }" :to="{ name: 'admin-options' }">Options</router-link>
      <router-link :class="{ active: $route.name == 'admin-users' }" :to="{ name: 'admin-users' }" v-if="currentUser.admin">Users</router-link>
      <router-link :class="{ active: $route.name == 'admin-assign-salesperson' }" :to="{ name: 'admin-assign-salesperson' }">Assign Salespeople</router-link>
      <router-link :class="{ active: $route.name == 'admin-logs' }" :to="{ name: 'admin-logs' }">Logs</router-link>
      <a class="fill"></a>
    </nav>
    <Users ref="Users" v-if="$route.name == 'admin-users'" @isDirty="(val) => (isDirty = val)" @isSaving="(val) => (isSaving = val)" />
    <Options v-if="$route.name == 'admin-options'" />
    <Logs v-if="$route.name == 'admin-logs'" :since="since" :type="type" :user="user" />
    <AssignSalespersonContacts ref="AssignSalespersonContacts" v-if="$route.name == 'admin-assign-salesperson'" @isDirty="(val) => (isDirty = val)" @isSaving="(val) => (isSaving = val)" />
  </div>
</template>

<script>
import Users from './admin/Users.vue';
import Options from './admin/Options.vue';
import Logs from './admin/Logs.vue';
import AssignSalespersonContacts from './admin/AssignSalespersonContacts.vue';
import useDecryptSymbols from '@/composables/useDecryptSymbols';
import useSaveProtect from '../composables/useSaveProtect';
import Dropdown from '@/components/inputs/Dropdown.vue';
import Confirmation from '@/components/Confirmation.vue';
import useUsersQuery from '@/composables/useUsersQuery';
import useLogsQuery from '@/composables/useLogsQuery';
import useCurrentUser from '@/composables/useCurrentUser';
import { ref, watch } from 'vue';

export default {
  name: 'Admin',
  components: {
    Users,
    Options,
    Logs,
    Dropdown,
    AssignSalespersonContacts,
    Confirmation,
  },
  setup() {
    const { decryptSymbols } = useDecryptSymbols();
    const { state: saveProtectState } = useSaveProtect();
    const { allUsers } = useUsersQuery();
    const { getLogActions } = useLogsQuery();
    const { user: currentUser } = useCurrentUser();

    const logActions = ref([]);

    const { result } = getLogActions();

    watch(result, () => {
      logActions.value = result.value?.logsActions || [];
    });

    return {
      decryptSymbols,
      saveProtectState,
      allUsers,
      logActions,
      currentUser,
    };
  },
  data() {
    return {
      isDirty: false,
      isSaving: false,
      isSearching: false,
      users: [],
      since: 'Last Week',
      type: 'all',
      user: 'all',
      duplicateType: 'companies',
      showTypeChangeConfirmation: false,
      pendingTypeChange: null,
      originalDuplicateType: 'companies',
    };
  },
  watch: {
    isDirty(val) {
      this.saveProtectState.isDirty = val;
    },
  },
  methods: {
    save() {
      if (this.$route.name == 'admin-user-permissions') this.$refs.UserPermissions.save();
      if (this.$route.name == 'admin-assign-salesperson') this.$refs.AssignSalespersonContacts.save();
    },
    add() {
      this.$refs.Users.add();
    },
    updateUsers(users) {
      const decrypted = JSON.parse(JSON.stringify(users)).map((user) => this.decryptSymbols(user));
      const filtered = decrypted.filter((user) => user.USERNAME);
      const sorted = filtered.sort((a, b) => a.USERNAME.localeCompare(b.USERNAME));
      sorted.forEach((user) => {
        user.USERNAME = user.USERNAME.charAt(0).toUpperCase() + user.USERNAME.slice(1);
      });
      this.users = sorted;
    },
    handleSearchStatusChange(status) {
      this.isSearching = status;
    },
  },
};
</script>

<style lang="scss" scoped>
.primary-input {
  z-index: 2;
}
</style>
